import {Directive} from "@angular/core";
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, Validators} from "@angular/forms";
import {FieldValidationMessage} from "../field/field-validation-message";

@Directive({
    selector: "[woa-phone-number]",
    providers: [{provide: NG_VALIDATORS, useExisting: PhoneNumberDirective, multi: true}]
})
export class PhoneNumberDirective implements Validator {
    validate(control: AbstractControl): ValidationErrors | null {
        return Validators.pattern("[+]?\\d{10,30}")(control)
            ? {phoneNumber: new FieldValidationMessage("phoneNumber", "woa.validation.common.phoneNumber")}
            : null;
    }
}
